import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/Home'
import FeedProcessor from '@/pages/FeedProcessor'
import Feeds from '@/pages/Feeds'
import PaymentSuccess from '@/pages/PaymentSuccess'
import ContactUs from '@/pages/ContactUs'
import PageNotFound from '@/pages/PageNotFound'
import PrivacyPolicy from '@/pages/PrivacyPolicy'

import adminLayout from '@/pages/Admin'
import adminUsers from '@/pages/Admin/Users'
import adminScenarios from '@/pages/Admin/Scenarios'
import adminFeedProcessors from '@/pages/Admin/FeedProcessors'
import adminCrawlers from '@/pages/Admin/Crawlers'
import adminEditScenario from '@/pages/Admin/EditScenario'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [


    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/Feeds/:id',
      name: 'Feeds',
      component: Feeds
    },
    {
      path: '/FeedProcessor/:id',
      name: 'FeedProcessor',
      component: FeedProcessor
    },
    {
      path: '/PaymentSuccess/:CHECKOUT_SESSION_ID',
      name: 'PaymentSuccess',
      component: PaymentSuccess
    },
    {
      path: '/ContactUs',
      name: 'ContactUs',
      component: ContactUs
    },
    {
      path: '/PrivacyPolicy',
      name: 'PrivacyPolicy',
      component: PrivacyPolicy
    },

    


/* ================= */
    {
      path: '/admin/',
      name: 'adminLayout',
      component: adminLayout,
      children: [
          { path: 'users', 
            name: 'adminUsers',
            component: adminUsers
          },
          {
            path: 'Scenarios',
            name: 'adminScenarios',
            component: adminScenarios
          },
          {
            path: 'Crawlers',
            name: 'adminCrawlers',
            component: adminCrawlers
          },
          {
            path: 'feedProcessors',
            name: 'adminFeedProcessors',
            component: adminFeedProcessors
          },
          {
            path: 'EditScenario/:id',
            name: 'adminEditScenario',
            component: adminEditScenario
          },
      ]
    },


    
/* ================= */

    {
      path: '/**',
      name: 'PageNotFound',
      component: PageNotFound
    },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js